module.exports = __webpack_public_path__ + "assets/admin-cover-1d43e8.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./Content/images/admin-cover.jpg
 ** module id = 920
 ** module chunks = 2
 **/